


































import Vue from 'vue'
import { EmojiPicker } from 'vue-emoji-picker'

export default Vue.extend({
  name: 'EmojiPickerTextField',
  components: { EmojiPicker },
  props: {
    disabled: Boolean,
    opened: Boolean
  },
  data () {
    return {
      search: '',
      emoji: ''
    }
  },
  directives: {
    focus: {
      inserted (el) {
        el.focus()
      }
    }
  },
  watch: {
    emoji (val) {
      if (val) {
        this.$emit('emoji', this.emoji)
        this.emoji = ''
      }
    }
  }
})
